module.exports = __webpack_public_path__ + "ba.no1.d0cc01c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ba.no1.jpg
// module id = Yow0
// module chunks = 0